import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { BrowserRouter as Router, Switch, Route, useLocation } from "react-router-dom";


const title = process.env.REACT_APP_TAB_TITLE;


// Set the title of the document
document.title = title;

ReactDOM.render(<Router><App /></Router>, document.getElementById('root'));

